var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.session)?_c('div',{staticClass:"game-responsive responsive_9x16"},[_c('iframe',{ref:"container",attrs:{"id":"vegas-container","sandbox":"allow-same-origin allow-scripts allow-popups allow-forms"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/game/game-vegas.vue?vue&type=template&id=3a7f294c
// module id = aWkm
// module chunks = 0